import React from 'react';
import { Utilities } from '../../utilities/utilities.ts';
import { Configuration } from '../../data/configuration.ts';

//-----------------------------------------------------------------------------------------
// Type Definitions:
//-----------------------------------------------------------------------------------------

interface SelectedSectionItemProps {
	itemName: string | JSX.Element;
	sectionPrice?: number;
}

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export default function SelectedSectionItem(props: SelectedSectionItemProps) {
	return (
		<div className="selected-item-container">
			{props.itemName && props.itemName !== 'None' && <p className="selected-item-name">{props.itemName}</p>}
			{props.sectionPrice && props.sectionPrice > 0 ? <p className="selected-item-price">{Utilities.asCurrency(props.sectionPrice, Configuration.regionCode)}</p> : null}
		</div>
	);
}
